<div class="graph__container">
    <div class="dashboard__tile__title graph__title">
        <span>{{ overheadCategoryWithFinancialData?.categoryName }}</span>

        <app-date-navigation
            [dateNavigationOptions]="dateNavigationOptions"
            [isCompact]="true"
            (selectedDateUpdated)="updateSelectedYear()">
        </app-date-navigation>
    </div>
    <div class="dashboard__tile__content graph__chart">
        <app-default-line-chart
            *ngIf="overheadCategoryWithFinancialData?.financialData; else loading"
            (clickEvent)="displayInfo($event)"
            [xLabels]="xLabels"
            [objectLabels]="labels"
            [data]="data"
            [legendPosition]="legendPosition"
            [options]="options"
            [chartType]="'bar'">
        </app-default-line-chart>

        <p>
            Average for {{ dateNavigationOptions.selectedDate | date: 'yyyy' }}: <b>{{ average | currency: 'EUR' }}</b>
        </p>
        <p>
            Total for {{ dateNavigationOptions.selectedDate | date: 'yyyy' }}: <b>{{ total | currency: 'EUR' }}</b>
        </p>
    </div>
</div>
<ng-template #loading>
    <app-loading-message class="graph__loading"></app-loading-message>
</ng-template>
